import { registerGroup, registerRect } from "@visactor/vrender-kits";

export function loadScrollbarComponent() {
    registerGroup(), registerRect();
}
//# sourceMappingURL=register.js.map
